import { ClientLayerError } from 'shared/errors/clientLayerError'

/** Logged when current template slice has no item during a fulfilled action. */
export class TemplateCurrentItemMissingError extends ClientLayerError {
  static readonly className: string = 'TemplateCurrentItemMissingError'

  constructor(operationDescription: string) {
    super(`item is null after ${operationDescription}`)
    this.setMarkupOptions({ scope: 'root', section: null })
    this.addFingerprintSegment('template-item-missing')
  }
}

/** Logged when template draft reducer receives a non-writable property update. */
export class TemplateDraftInvalidPropertyError extends ClientLayerError {
  static readonly className: string = 'TemplateDraftInvalidPropertyError'

  constructor(property: string) {
    super(`Template draft reducer: cannot update property: "${property}"`)
    this.setMarkupOptions({ scope: 'templates', section: 'draft' })
    this.addFingerprintSegment('template-draft-invalid-property')
  }
}
